import { render, staticRenderFns } from "./CompetenceEvent.vue?vue&type=template&id=5338f5bc&scoped=true"
import script from "./CompetenceEvent.vue?vue&type=script&lang=js"
export * from "./CompetenceEvent.vue?vue&type=script&lang=js"
import style0 from "./CompetenceEvent.vue?vue&type=style&index=0&id=5338f5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5338f5bc",
  null
  
)

export default component.exports